import { render, staticRenderFns } from "./ReturnPartsView.vue?vue&type=template&id=a61c351c"
import script from "./ReturnPartsView.vue?vue&type=script&lang=js"
export * from "./ReturnPartsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports